import { createClient } from '@supabase/supabase-js'

// Project configuration
const SUPABASE_URL = 'https://qvctshxeertvgzspmeof.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF2Y3RzaHhlZXJ0dmd6c3BtZW9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxNTUzNjQsImV4cCI6MjA5MzczMTM2NH0.EYDaql2sE_CLOSaSebWwBw5uYRw43gRbI6Kqkcn-dWI'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})